import styled from '@emotion/styled';
import { Box, TransparentButton } from '~Styles';
import { insideWrapperStyles } from '~ComponentsImproved/Modal';
import { handyBreakpoint } from '~Styles/breakpoints';
import NavigateLeftIcon from '~/Assets/icons/navigate-left.svg';

export const ModalWrapper = styled(Box)`
  position: relative;
  overflow-y: auto;
  box-shadow: ${insideWrapperStyles.boxShadow};
  border-radius: ${insideWrapperStyles.borderRadius};
  background-color: ${insideWrapperStyles.backgroundColor};
  animation: fadeIn 1s ease;
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  ${handyBreakpoint} {
    height: 100vh;
  }
`;

export const BackButton = styled(TransparentButton)`
  position: absolute;
  top: 16px;
  left: 16px;
  color: var(--colorBlueGray800);
  font-size: 16px;
  text-transform: none;
  z-index: 1000 !important;

  ${handyBreakpoint} {
    top: 0px;
    left: 0px;
    font-size: 12px;
  }
`;

export const BackButtonIcon = styled.div`
  width: 32px;
  height: 32px;
  mask-image: url(${NavigateLeftIcon});
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: var(--colorBlueGray800);
  margin-right: 8x;

  ${handyBreakpoint} {
    width: 24px;
    height: 24px;
  }
`;

export const FormatInput = styled.input`
  border-radius: 4px;
  border: 1px solid var(--colorBlueGray1000);
  height: 64px;
  background-color: var(--colorBlueGray1100);
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  font-size: 24px;
  font-weight: 500;
  color: var(--colorWhite);
  padding: 0 20px;
  &:focus {
    border-color: var(--colorBlueGray1000);
    outline: none;
  }
  ${handyBreakpoint} {
    font-size: 20px;
    height: 48px;
    margin: 0px;
    width: 80%;
  }
`;

export const HeaderBox = styled(Box)<{ minHeight?: string }>`
  max-width: 480px;
  text-align: center;
  ${({ minHeight }) => minHeight && `min-height: ${minHeight};`}
`;
